import { render, staticRenderFns } from "./ViFeesPlan.vue?vue&type=template&id=405da024"
import script from "./ViFeesPlan.vue?vue&type=script&lang=js"
export * from "./ViFeesPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports